<template>
    <div>
        <div class=" flex items-center justify-between px-3 transition-all duration-200" :class="[!collapse && 'mb-4']">
            <span class=" text-gray-400">STATUS TIMELINE</span>
            <span class=" cursor-pointer flex items-center gap-2" @click="collapse = !collapse">Collapse <img
                    src="@/assets/images/arrow-up.svg" :class="[collapse && 'rotate-180']"
                    class=" transition-all duration-200" /></span>
        </div>
        <div v-if="!collapse">
            <div v-for="(timeline, index) in shippingTimeline.timelineLogs" :key="index + 'timeline'"
                class="timeline_wrapper">
                <div class="timeline_item relative">
                    <img v-if="index !== (shippingTimeline.timelineLogs.length - 1)" src="@/assets/images/checkmark.png"
                        class="check_img" />
                    <span v-if="index === (shippingTimeline.timelineLogs.length - 1)" class="current_ball"></span>
                    <label v-if="index === (shippingTimeline.timelineLogs.length - 1)">CURRENT</label>
                    <b :class="[index === (timeline.length - 1) && ' text-primary-yellow']">{{
                        timeline.activityType.replace(/_/g, ' ') }}</b>
                    <p>{{ formatDate(timeline?.createdAt) }}</p>
                    <p>{{ timeline?.updatedBy?.address}}</p>
                    <div v-if="timeline?.updatedBy?.id" class="updated_note">
                        Shipment updated by {{ timeline?.updatedBy?.firstname }} {{ timeline?.updatedBy?.lastname }}
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
    props: {
        shippingTimeline: {}
    },
    methods: {
        formatDate(date) {
            return moment(date).format('DD/MM/YY hh:mma')
        }
    },
    data() {
        return {
            collapse: false
        }
    },
}
</script>

<style lang="scss" scoped>
.timeline_item {
    @apply w-6/12 px-5 py-6 relative;

    b {
        @apply font-[500] w-full block capitalize
    }

    p {
        @apply text-gray-400 font-[300] text-sm
    }

    label {
        @apply px-2 py-1 rounded-md bg-primary-yellow w-auto text-xs text-white
    }
}

.timeline_wrapper:nth-child(even) .timeline_item {
    @apply text-right border-r border-r-gray-300;

    span {
        @apply block w-full
    }
}

.timeline_wrapper:nth-child(odd) {
    @apply flex justify-end;
}

.timeline_wrapper:nth-child(odd) .timeline_item {
    @apply w-6/12 py-4 border-l border-l-gray-300 relative -left-[1px];
}

.timeline_wrapper {
    @apply flex
}

.timeline_wrapper:nth-child(odd) .updated_note {
    @apply absolute left-[calc(0%-280px)] sm:w-[250px] w-full py-3 px-3 rounded-xl bg-primary-navy text-white top-[15px] text-xs
}

.timeline_wrapper:nth-child(even) .updated_note {
    @apply absolute right-[calc(0%-280px)] sm:w-[250px] w-full py-3 px-3 rounded-xl bg-primary-navy text-white top-[15px] text-left text-xs
}

.timeline_wrapper:nth-child(odd) .timeline_item .current_ball {
    @apply inline-flex w-[20px] h-[20px] border-[1.5px] border-primary-yellow rounded-full absolute top-[20px] -left-[10px] bg-white justify-center items-center;

    &::before {
        content: "";
        @apply w-[70%] h-[70%] bg-primary-yellow rounded-full block
    }
}

.timeline_wrapper:nth-child(odd) .timeline_item .check_img {
    @apply inline-flex w-[20px] h-[20px] border-[1.5px] border-primary-yellow rounded-full absolute top-[20px] -left-[10px] bg-white justify-center items-center;

    &::before {
        content: "";
        @apply w-[70%] h-[70%] bg-primary-yellow rounded-full block
    }
}


.timeline_wrapper:nth-child(even) .timeline_item .current_ball {
    @apply inline-flex w-[20px] h-[20px] border-[1.5px] border-primary-yellow rounded-full absolute top-[25px] -right-[10px] bg-white justify-center items-center;

    &::before {
        content: "";
        @apply w-[70%] h-[70%] bg-primary-yellow rounded-full block
    }
}

.timeline_wrapper:nth-child(even) .timeline_item .check_img {
    @apply inline-flex w-[20px] h-[20px] border-[1.5px] border-primary-yellow rounded-full absolute top-[27px] -right-[10px] bg-white justify-center items-center;

    &::before {
        content: "";
        @apply w-[70%] h-[70%] bg-primary-yellow rounded-full block
    }
}

.timeline_wrapper:nth-of-type(1) .timeline_item .current_ball {
    @apply inline-flex w-[20px] h-[20px] border-[1.5px] border-primary-yellow rounded-full absolute top-[0px] -right-[10px] bg-white justify-center items-center;

    &::before {
        content: "";
        @apply w-[70%] h-[70%] bg-primary-yellow rounded-full block
    }
}
.timeline_wrapper:nth-of-type(1) .timeline_item .check_img {
    @apply inline-flex w-[20px] h-[20px] border-[1.5px] border-primary-yellow rounded-full absolute top-[0px] -left-[10px] bg-white justify-center items-center;

    &::before {
        content: "";
        @apply w-[70%] h-[70%] bg-primary-yellow rounded-full block
    }
}
.timeline_wrapper:nth-of-type(1) .timeline_item {
    padding-top: 0px;
}

.timeline_wrapper:nth-of-type(1) .updated_note {
    @apply absolute left-[calc(0%-280px)] sm:w-[250px] w-full py-3 px-3 rounded-xl bg-primary-navy text-white top-[0px] text-xs
}

</style>